import { render, staticRenderFns } from "./tabCrmCustomerEvent.vue?vue&type=template&id=8d80b57e&scoped=true&"
import script from "./tabCrmCustomerEvent.vue?vue&type=script&lang=js&"
export * from "./tabCrmCustomerEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d80b57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d80b57e')) {
      api.createRecord('8d80b57e', component.options)
    } else {
      api.reload('8d80b57e', component.options)
    }
    module.hot.accept("./tabCrmCustomerEvent.vue?vue&type=template&id=8d80b57e&scoped=true&", function () {
      api.rerender('8d80b57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerEvent.vue"
export default component.exports